import React, { useState, useEffect, useContext } from 'react'
import { Box, TextField, InputLabel  } from '@mui/material'
import { PercentFormatInputDefault } from '../../../Utils/PercentInputDefault'
import ColorButton from '../../../Buttons/ColorButton'
import { externalComponent } from '../../../AppRoutes'
import { api } from '../../../../services/api'
import toast from 'react-hot-toast'

const changePercent = (setPrecoMinimo, value) => {
    setPrecoMinimo(value)
}

const getPrecoMinimo = async (setLoader,setPrecoMinimo) => {
    setLoader(true)
    const res = await api.get('preco_minimo')
    if (res.status === 200) {
        setPrecoMinimo(res.data.preco_minimo)
    }
    setLoader(false)
}

const savePrecoMinimo = async (setLoader, precoMinimo) => {
    const obj = {preco_minimo:precoMinimo}
    setLoader(true)
    const res = await api.post('preco_minimo', obj)
    if (res.status === 200) {
        toast.success('Preço mínimo salvo com sucesso')
    }
    setLoader(false)
}

const PrecoMinimo = () => {

    const [precoMinimo, setPrecoMinimo] = useState(0)
    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        getPrecoMinimo(setLoader,setPrecoMinimo)
    }, [])

    return(
        <>
        <Box sx={{display:'flex', flexDirection:'row', alignItems:'flex-end', gap:'1rem'}}>
            <Box>
                <InputLabel>Preço Mínimo</InputLabel>
                <TextField
                    id="preco_minimo"
                    type="text"
                    value={precoMinimo}
                    onChange={(e)=> changePercent(setPrecoMinimo, e.target.value)}
                    fullWidth={false}
                    size='small'
                    InputProps={{
                        inputComponent: PercentFormatInputDefault,
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                />
            </Box>
            <Box>
                <ColorButton onClick={()=> savePrecoMinimo(setLoader, precoMinimo)} sx={{height:'2.5rem'}}>Salvar</ColorButton>
            </Box>
        </Box>
        </>
    )
}

export default PrecoMinimo;